import { get } from 'lodash';
import React from 'react';
import { OriCheckbox, OriSelect, Select } from 'src/components/Antd';
import DragNDropColumns from 'src/components/DragNDropColumns';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import {
  ResponsiveAnimation,
  ResponsiveContentText,
  ResponsiveModuleStyle,
} from 'src/components/Modules/Components';
import Switcher from 'src/components/SectionSwitcher';
import {
  EModuleWidth,
  EOverflowOption,
  EResponsiveCarouselModuleSwitcherType,
  EResponsiveContentPageToShow,
} from 'src/types/common/module';
import css from './css.module.less';
const Option = OriSelect.Option;
//import { uuid } from '@/src/tools/helper';
import _ContentPage from 'src/components/Modules/Components/ContentImageDragItem';
import { errKeys as contentErr } from 'src/components/Modules/Components/ContentImageDragItem/tools';
import { moduleStyleProps } from 'src/components/Modules/Components/ModuleStyle/tools';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import { EPreviewSize } from 'src/types/common/SalesChannel';
const ResponsiveContentGrid = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //console.log(props);
  const {
    onItemAdd,
    onItemChange,
    onItemDelete,
    onItemSort,
    onStaticChange,
    contentPages,
    contentPageList,
    specificError,
    staticData,
    breakpoint,
    animations,
    hoverAnimations,
  } = props;

  const isConvertible = breakpoint && breakpoint !== EPreviewSize.WIDE;
  // console.log('isConvertible', isConvertible, breakpoint);
  const isMobile = breakpoint === EPreviewSize.MOBILE;
  const {
    contentPageToShowError,
    contentPageToShowMismatchError,
    contentPages: contentPagesHasError = [],
  } = specificError;

  //console.log('specificError', specificError);

  const draggableId = get(staticData, 'draggableId');
  const contentPagesToShow = get(staticData, 'contentPagesToShow');
  const leaveGap = get(staticData, 'leaveGap');
  const animation = get(staticData, 'animation');
  const moduleStyle = get(staticData, 'moduleStyle');
  const moduleWidth = get(staticData, 'moduleWidth');
  const overflowOption = get(staticData, 'overflowOption');

  const switcherType =
    get(staticData, 'switcherType') ||
    EResponsiveCarouselModuleSwitcherType.ModuleStyle;
  const text = get(staticData, 'moduleText');
  // const handleOnActionButtonThemeChange = (actionButtonTheme) => {
  //   onStaticChange({ actionButtonTheme });
  // };

  // const dict = {
  //   [EResponsiveContentPageToShow.One]: 1,
  //   [EResponsiveContentPageToShow.TwoLandscape]: 2,
  //   [EResponsiveContentPageToShow.TwoPortrait]: 2,
  //   [EResponsiveContentPageToShow.Three]: 3,
  //   [EResponsiveContentPageToShow.Four]: 4,
  //   [EResponsiveContentPageToShow.Five]: 5,
  //   [EResponsiveContentPageToShow.Six]: 6,
  // };

  const isOneContentPageOnScreen =
    contentPagesToShow === EResponsiveContentPageToShow.One;

  const handleOnLeaveGapChange = (e) => {
    const leaveGap = e.target.checked;
    onStaticChange({ leaveGap });
  };

  const handleOnModuleTypeChange = (switcherType) => {
    onStaticChange({ switcherType: switcherType });
  };

  const handleOnModuleWidthChange = (moduleWidth) => {
    onStaticChange({ moduleWidth });
  };

  const handleOnOverflowOptionChange = (overflowOption) => {
    onStaticChange({ overflowOption });
  };

  const handleOnContentPagesToShowChange = (contentPagesToShow) => {
    onStaticChange({ contentPagesToShow });
  };

  const handleModuleStyleChange = (style) => {
    const newStyle = { ...(moduleStyle || {}), ...style };
    onStaticChange({ moduleStyle: newStyle });
  };

  const handleAnimationChange = (ani) => {
    const newAnimation = { ...(animation || {}), ...ani };
    onStaticChange({ animation: newAnimation });
  };

  const handleTextChange = (ani) => {
    const newText = { ...(text || {}), ...ani };
    onStaticChange({ moduleText: newText });
  };

  const handleOnItemAdd = () => {
    onItemAdd();
  };

  const handleItemOnSort = (obj) => {
    const { data } = obj;
    const { newIndex, oldIndex } = data || {};
    onItemSort(oldIndex, newIndex);
  };

  const handleOnItemDelete = (index) => {
    if (onItemDelete) {
      onItemDelete(index);
    }
  };

  const childGenerate = (data, index) => {
    const contentPage = get(data, 'contentPage');
    const summary = get(data, 'summary');
    const image = get(data, 'image');
    const subtitle = get(data, 'subtitle');
    const draggableId = get(data, 'draggableId');

    const _specificError = Object.keys(specificError).reduce((pre, now) => {
      if (now.startsWith(draggableId)) {
        const v = specificError[now];

        const item = now.split(draggableId)[1];
        return { ...pre, [item]: v };
      }
      return pre;
    }, {});

    return (
      <_ContentPage
        isPrimary={true}
        specificError={_specificError}
        errKeys={contentErr}
        index={index}
        contentPageList={contentPageList}
        sectionContainer={css.contentPageSectionContainer}
        contentPage={contentPage}
        image={image}
        summary={summary}
        subtitle={subtitle}
        onChange={onItemChange}
        onDelete={handleOnItemDelete}
      />
    );
  };

  const renderContentPagesToShow = () => {
    return [
      <Option
        value={EResponsiveContentPageToShow.One}
        key={EResponsiveContentPageToShow.One}>
        {getI18n('general.oneContentPageOnScreen')}
      </Option>,
      isMobile
        ? [
            <Option
              value={EResponsiveContentPageToShow.Two}
              key={EResponsiveContentPageToShow.Two}>
              {getI18n('general.twoContentPagesOnScreen')}
            </Option>,
          ]
        : [
            <Option
              value={EResponsiveContentPageToShow.TwoLandscape}
              key={EResponsiveContentPageToShow.TwoLandscape}>
              {getI18n('general.twoContentPagesOnScreen')} (
              {getI18n('general.landscape')})
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.TwoPortrait}
              key={EResponsiveContentPageToShow.TwoPortrait}>
              {getI18n('general.twoContentPagesOnScreen')} (
              {getI18n('general.portrait')})
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.Three}
              key={EResponsiveContentPageToShow.Three}>
              {getI18n('general.threeContentPagesOnScreen')}
            </Option>,
          ],
      ,
      ...(isConvertible
        ? []
        : [
            <Option
              value={EResponsiveContentPageToShow.Four}
              key={EResponsiveContentPageToShow.Four}>
              {getI18n('general.fourContentPagesOnScreen')}
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.Five}
              key={EResponsiveContentPageToShow.Five}>
              {getI18n('general.fiveContentPagesOnScreen')}
            </Option>,
            <Option
              value={EResponsiveContentPageToShow.Six}
              key={EResponsiveContentPageToShow.Six}>
              {getI18n('general.sixContentPagesOnScreen')}
            </Option>,
          ]),
    ];
  };

  return (
    <React.Fragment>
      {!isConvertible && (
        <Section size='small' bottomBorder className={css.container}>
          <ItemWrapper title={getI18n('general.moduleWidth')}>
            <OriSelect
              size='large'
              value={moduleWidth}
              onChange={handleOnModuleWidthChange}>
              <Option value={EModuleWidth.WIDE}>
                {getI18n('general.wideWidth')}
              </Option>
              <Option value={EModuleWidth.NONE}>
                {getI18n('general.status.none')}
              </Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}

      <Section size='small' bottomBorder>
        <ItemWrapper title={getI18n('general.contentPagesToShow')}>
          <Select
            error={contentPageToShowError.length > 0}
            help={contentPageToShowError.join(' ')}
            size='large'
            value={contentPagesToShow}
            onChange={handleOnContentPagesToShowChange}>
            {renderContentPagesToShow()}
          </Select>
        </ItemWrapper>
        {!isOneContentPageOnScreen && (
          <div className={css.gapContainer}>
            <OriCheckbox checked={leaveGap} onChange={handleOnLeaveGapChange}>
              {getI18n('general.leavegapbetweencontentpages')}
            </OriCheckbox>
          </div>
        )}
      </Section>
      {isConvertible && (
        <Section size='small' bottomBorder>
          <ItemWrapper title={getI18n('general.overflowItemsDisplayOption')}>
            <OriSelect
              size='large'
              value={overflowOption}
              onChange={handleOnOverflowOptionChange}>
              <OriSelect.Option value={EOverflowOption.Carousel}>
                {getI18n('general.convertToCarousel')}
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.AnotherLine}>
                {getI18n('general.shiftToAnotherLine')}
              </OriSelect.Option>
              <OriSelect.Option value={EOverflowOption.Hide}>
                {getI18n('general.hide')}
              </OriSelect.Option>
            </OriSelect>
          </ItemWrapper>
        </Section>
      )}
      <Section size='small' className={css.switcherContainer}>
        <Switcher
          selectContainer={css.switcher}
          selected={switcherType}
          onChange={handleOnModuleTypeChange}
          allSections={{
            [EResponsiveCarouselModuleSwitcherType.ModuleStyle]: {
              title: getI18n('general.moduleStyle'),
              hasError: false,
              child: (
                <div className={css.paddingContainer}>
                  <ResponsiveModuleStyle
                    {...moduleStyleProps(moduleWidth)}
                    data={moduleStyle}
                    onChange={handleModuleStyleChange}
                    isMobileOrTablet={isConvertible}
                  />
                </div>
              ),
            },
            ...(isConvertible
              ? {}
              : {
                  [EResponsiveCarouselModuleSwitcherType.Animation]: {
                    title: getI18n('general.sider.animation'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveAnimation
                          data={animation}
                          onChange={handleAnimationChange}
                          animations={animations}
                          hoverAnimations={hoverAnimations}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.Text]: {
                    title: getI18n('general.text'),
                    hasError: false,
                    child: (
                      <div className={css.paddingContainer}>
                        <ResponsiveContentText
                          data={text}
                          onChange={handleTextChange}
                        />
                      </div>
                    ),
                  },
                  [EResponsiveCarouselModuleSwitcherType.ContentPage]: {
                    title: getI18n('general.sider.contentPage'),
                    hasError:
                      (contentPageToShowMismatchError || []).length > 0 ||
                      contentPagesHasError.length > 0,
                    child: (
                      <DragNDropColumns
                        // disabled={!isPrimary}
                        // hideAdd={!isPrimary}
                        hideTitle
                        childGenerate={childGenerate}
                        data={contentPages}
                        droppableId={`salesChannelContentListContentPagesGrid${draggableId}`}
                        onSort={handleItemOnSort}
                        // hideAdd={hideAdd}
                        onAdd={handleOnItemAdd}
                        addText={`+ ${getI18n('general.addContentPage')}`}
                        //onDelete={handleOnItemDelete}
                      />
                    ),
                  },
                }),
          }}
        />
      </Section>
    </React.Fragment>
  );
};
export default ResponsiveContentGrid;
